import * as React from "react";
import { classNames } from "src/common/classNames";
import { Button } from "antd";
import {
  DownOutlined,
  PlusCircleFilled,
  PlusOutlined,
  UpOutlined,
} from "@ant-design/icons";
import { onError } from "src/common/onError";
import { ZUid } from "src/types/zUid";
import { Bom2aEdPosition, ZBom2aMaterialDesc } from "../Bom2aPositionsTypes";
import { Bom2aPositionsStore } from "../Bom2aPositionsStore";
import styles from "./Bom2aPositionsTable.module.less";
import { SelectBom2aMaterial } from "./SelectBom2aMaterial";
import { createBom2aPositions } from "../apiBom2aPositions";

type PropsBom2aPositionItem = {
  viewMode?: boolean;
  position: Bom2aEdPosition;
  store: Bom2aPositionsStore;
};

const spanValue = (value: number | undefined): string | undefined =>
  value ? `span ${value}` : undefined;

export const Bom2aPositionItem: React.FC<PropsBom2aPositionItem> = (props) => {
  const { viewMode, position, store } = props;
  const { materialTypeId, materialTypeName, bomPositionRows } = position;
  const [curMaterialId, setCurMaterialId] = React.useState<ZUid>("");

  const onMaterialsList = async (list: ZBom2aMaterialDesc[]) => {
    await store.updateTask(async () => {
      await createBom2aPositions({
        bomId: store.bomId,
        descriptionIds: list.map(({ id }) => id) as string[],
      });
    });
  };

  return (
    <div
      className={classNames([styles.positionTitle, styles.posHd])}
      style={{ gridColumn: spanValue(store.finalColumns.length - 1) }}
    >
      {!viewMode && (
        <>
          <Button
            size="small"
            type="primary"
            title="Создание позиции путем выбора из библиотеки материалов"
            icon={<PlusOutlined />}
            onClick={() => setCurMaterialId(materialTypeId)}
          />
          <Button
            size="small"
            icon={<PlusCircleFilled />}
            title="Создание позиции путем ввода данных вручную"
            onClick={() => {
              store.createEmptyPosition(materialTypeId).catch(onError);
            }}
          />
        </>
      )}
      {bomPositionRows.length === 0 ? (
        <span className={styles.matName}>{materialTypeName}</span>
      ) : (
        <Button
          type="text"
          icon={
            store.collapsed.has(materialTypeId) ? (
              <DownOutlined />
            ) : (
              <UpOutlined />
            )
          }
          onClick={() => store.toggleCollapsing(materialTypeId)}
        >
          <span className={styles.matName}>{materialTypeName}</span>
        </Button>
      )}
      <SelectBom2aMaterial
        materialTypeId={curMaterialId}
        multi
        open={!!curMaterialId}
        close={() => setCurMaterialId("")}
        exec={(list) => onMaterialsList(list)}
        title="Создание позиций из справочника"
      />
    </div>
  );
};
